<template>
  <div>
    <h2 class="bordered-box-header text-center">{{firstName}} {{lastName}}</h2>
    <b-card no-body>
      <b-tabs card>
        <b-tab title="Konto lektora">
          <user :id="id" />
        </b-tab>
        <b-tab title="Kalendarz">
          <calendar :id="id" />
        </b-tab>
        <b-tab title="Opinie kursantów">
          <rating :id="id" />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import user from "./components/DetailsUser";
import calendar from "./../DetailsCalendar";
import rating from "./components/DetailsRating";
import { axios, eventBus } from "@/_infrastructure";

export default {
  data() {
    return {
      firstName: null,
      lastName: null
    };
  },
   mounted() {
    if (this.id) {
      axios
        .get("/lectors/details/", {
          params: {
            id: this.id
          }
        })
        .then(response => {
          var result = response.data;
          this.firstName = result.firstName;
          this.lastName = result.lastName;
        })
        .catch(error => eventBus.$emit("unhandled-error", error))
    }
  },

  props: ["id"],
  components: { user, calendar, rating }
};
</script>

<style lang="scss" scoped>
.tabs /deep/ .tab-pane:focus {
  outline: none;
}
h2.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-bottom: 0px;
}
</style>